import * as angular from 'angular';
import SetupTagGroupsBridge from './SetupTagGroupsBridge';
angular
  .module('flowingly.runner.setup')
  .component('setupTagGroups', SetupTagGroupsBridge);
